function validate(values) {
  let errors = {};
  // if (!values.email_address || !validateEmail(values.email_address)) {
  //   errors.email_address = "Please enter a valid email address.";
  // }
  // if (!values.reason_to_be_chim) {
  //   errors.reason_to_be_chim = "Please enter a good reason to be a Chimney.";
  // }
  return errors;
}

export { validate };
